module.exports = __webpack_public_path__ + "img/chloe-ting.aa9cd7ec.jpg";